export default {
  title: {
    nl: 'McDONALD’S DEALS KALENDER',
  },
  description: {
    nl: 'Deal gemist? Kom elke dag terug en check of er nog lekkere Deals voor je klaar staan.',
  },
  cta: {
    nl: 'NAAR JE DEALS',
  },
  timer: {
    nl: 'Volgende DealS over:',
  }
};